import axios from "axios";
import { RequestPaymentData } from "../services/payment/types";
import { BookingTypeForBackend, CustomerType, PatientType } from "../services/types";

const { REACT_APP_API_URL } = process.env;

const baseURL = REACT_APP_API_URL;

export const httpInstance = axios.create({ baseURL });

const { REACT_APP_PAYMENT_URL } = process.env;

const basePaymentURL = REACT_APP_PAYMENT_URL;

export const httpPayment = axios.create({ baseURL: basePaymentURL });

const defaultHeaders = {
  "Content-Type": "application/json",
};

export const getRequest = async (resource: string, headers = null) => {
  try {
    const response = await httpInstance.get(resource, {
      headers: headers || defaultHeaders,
    });
    return response;
  } catch (error) {
    console.log("Error tryng to do request to server: ", error);
  }
};

export const createAppointment = async (
  booking: BookingTypeForBackend,
  customer: CustomerType,
  patients: PatientType[]
) => {
  try {
    const response = await httpInstance.post("appointments", {
      headers: defaultHeaders,
      data: {
        booking: booking,
        customer: customer,
        patients: patients,
      },
    });
    return response;
  } catch (error) {
    console.log("Error tryng to do request to server: ", error);
  }
};

export const getRequestPayment = async (
  resource: string,
  reqData: RequestPaymentData
) => {
  try {
    const response = await httpPayment.post(resource, {
      headers: defaultHeaders,
      data: reqData,
    });
    return response;
  } catch (error) {
    console.log("Error tryng to do request to server: ", error);
  }
};
